import Axios from '@/utils/axios'

export default {
  buscaAssinatura: () => Axios.get('/usuarios/assinatura'),
  storeAssinatura: file => {
    const formData = new FormData()
    formData.append('file', file)
    return Axios.post('/ficha-clinica/assinatura', formData)
  }
}
